import { formatDecimal } from "../../../utils";

export const toTableRowItems = (items: DifferencesProduct[]) =>
  items.map((item: DifferencesProduct) => ({
    id: item.id,
    externalTicketId: item.externalTicketId || '',
    shopName: item.shopName || '',
    shopCode: item.shopCode || '',
    depositName: item.depositName || '',
    productCode: item.productCode || '',
    productName: item.productName || '',
    originalOrderId: item.originalOrderId || '',
    metiOrderId: item.metiOrderId || '',
    measureUnit: item.measureUnit || '',
    transportCode: item.transportCode || '',
    orderedQuantity: formatDecimal(item.orderedQuantity) || '',
    receivedQuantity: formatDecimal(item.receivedQuantity) || '',
    brokenQuantity: formatDecimal(item.brokenQuantity) || '',
    receptionDeviation: item.receptionDeviation || '',
    stockQuantity: formatDecimal(item.stockQuantity) || '',
    missingQuantity: formatDecimal(item.missingQuantity) || '',
    transporterCode: item.transporterCode || '',
    created: item.metiSentDate || '',
    integrationOperator: item.integrationOperator || '',
    archivePath: item.archivePath
  }))
